<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Semester Attendance Report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
              :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
              @click="putnull" persistent-hint hint="Please Select Academic Year " />
          </v-col>
          <v-col sm="2" v-if="std_div_list != null">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
              :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" @click="putnull"
              persistent-hint hint="Please Select Standard " />
          </v-col>
          <v-col sm="2" v-if="div_list != null">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
              item-text="div_name" label="Division" outlined @click="putnull" persistent-hint
              hint="Please Select Division" />
          </v-col>
          <v-col sm="2" v-if="div_list != null">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="semester" :items="sem_list" item-text="sem"
              item-value="id" label="Select Semester" outlined persistent-hint hint="Please Select Semester" />
          </v-col>
          <v-col cols="12" sm="2" md="2" v-if="div_list != null">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="stud_status" :items="status_list"
              item-text="name" return-object label="Status" outlined persistent-hint hint="Select Status" />
          </v-col>
          <v-col sm="2" v-if="sel_ay_data && sel_std_data && div && semester">
            <v-btn class="mt-6 button" @click="getSemesterAttendanceData()" :loading="fetch_loader">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="learner_attendance_info.length > 0">
        <!-- <v-col
          cols="12"
          sm="2"
          md="2"
          v-if="learner_attendance_info.length != 0"
        > -->
        <!-- <v-btn color="success" outlined rounded>
            <download-excel
              class="mr-2 pb-3 pt-2"
              :data="learner_attendance_info"
              :fields="table_fields"
              worksheet="SemesterWiseAttendendance"
              name="SemesterWiseAttendendance.xls"
            >
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn>-->
        <!-- </v-col> -->
        <!-- export btn code -->
        <v-col cols="6" sm="2" md="2">
          <v-btn class="ma-2 no-display " rounded color="success" outlined v-if="learner_attendance_info.length != 0"
            @click="fnExcelReport('my-table-id', 'SemesterWiseAttendanceReport')" :loading="loader"><v-icon
              color="success">mdi-export</v-icon>Export</v-btn>
        </v-col>
        <div id="my-table-id">
          <v-data-table :headers="headers" :items="learner_attendance_info">
            <template v-slot:top>
              <v-toolbar flat class="toolbar">
                <v-toolbar-title>Attendance Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:[`item.is_present`]="{ item }">
              <v-avatar color="success" size="30" v-if="item.is_present == true">
                <span class="white--text headline">P</span>
              </v-avatar>

              <v-avatar v-else color="error" size="30">
                <span class="white--text headline">A</span>
              </v-avatar>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    stud_status:"",status_list:[],
    loader: false,
    snackbar_msg: "",
    color: "",
    // extraBreadcrumbItems: [
    

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    snackbar: false,
    title: "",
    description: "",
    headers: [
      { text: "Sr No", value: "srno" },
      { text: "Date", value: "date" },
      { text: "Standard", value: "standard" },
      { text: "Division", value: "division" },
      { text: "Total", value: "total" },
      { text: "Present", value: "total_present" },
      { text: "Absent", value: "total_absent" },
      { text: "Percentage", value: "percentage" },
    ],
    // table_fields: {
    //   "Sr. No": "srno",
    //   Date: "date",
    //   Standard: "standard",
    //   Division: "division",
    //   Total: "total",
    //   Present: "total_present",
    //   Absent: "total_absent",
    //   Percentage: "percentage",
    // },
    ay_std_div_list: null,
    sel_ay_data: null,
    show_tt: false,
    std_div_list: null,
    sel_std_data: null,
    div_list: null,
    div: null,
    overlay: false,
    fetch_loader: false,
    sem_list: "",
    semester: "",
    learner_attendance_info: [],
  }),
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Date</th>
      <th>Standard</th>
      <th>Division</th>
      <th>Total</th>
      <th>Present</th>
      <th>Absent</th>
      <th>Percentage</th>
    </tr>`;

  this.learner_attendance_info.forEach((item, index) => {
    tab_text += `
      <tr>
        <td>${index + 1}</td>
        <td>${item.date}</td>
        <td>${item.standard}</td>
        <td>${item.division}</td>
        <td>${item.total}</td>
        <td>${item.total_present}</td>
        <td>${item.total_absent}</td>
        <td>${item.percentage}</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},

    getSemesterAttendanceData() {
      const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        division_offering: this.div,
        semester: this.semester,
        status:this.stud_status.id
      };
      this.overlay = true;
      axios
        .post("/Academics/getSemesterAttendanceData", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.learner_attendance_info = res.data.learner_attendance_info;
            this.overlay = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    putnull() {
      this.learner = [];
    },
    onLoad() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
          this.sem_list = res.data.semester_list;
          this.status_list = res.data.learner_status_list;
          this.stud_status = this.status_list[0];
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>